import script from "./AdvertApproval.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertApproval.vue?vue&type=script&setup=true&lang=js"

import "./AdvertApproval.vue?vue&type=style&index=0&id=03b8fd01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b8fd01"]])

export default __exports__